import { httpGet } from "./http-client";

const apiUrl = '/api/roles';

export const getMenuItems = () => httpGet<string[]>(`${apiUrl}/menuitems`);
